const nav = document.getElementById('nav');

function renderChrome() {
  nav.classList.toggle('solid', scrollY > 36);
}

addEventListener('scroll', renderChrome, { passive: true });
renderChrome();

const observer = new IntersectionObserver(
  entries => entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('on');
      observer.unobserve(entry.target);
    }
  }),
  { threshold: 0.14 }
);

document.querySelectorAll('.reveal').forEach(element => observer.observe(element));
